export default __webpack_public_path__ + "static/media/carriers.85a8b6b9.svg";